import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import './DistributorsForm.css';
import Header from "../../components/Header";
import Section from "../../components/Section";
import Select from "react-select";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSave,
    faRotate,
    faCircleArrowLeft,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";

const DistributorsForm = ({ handleLogout }) => {
    const navigate = useNavigate();
    const { codeDistributor } = useParams();
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [client, setClient] = useState("");
    const [clientSearch, setClientSearch] = useState("");
    const [clientsData, setClientsData] = useState([]);
    const [searchTermClient, setSearchTermClient] = useState(''); // Para el valor de búsqueda
    const [purchaseBlock, setPurchaseBlock] = useState(false);
    const [blockReason, setBlockReason] = useState("");
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [isInfoVisible, setIsInfoVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState({});
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);

    const toggleSwitch = () => {
        setPurchaseBlock((prev) => !prev);
    };

    const validateFields = () => {
        let validationErrors = {};
        const onlyLetters = /^[a-zA-Z]+$/;
        if (!code) {
            validationErrors.code = "El Campo es Obligatorio";
        } else if (!onlyLetters.test(code)) {
            validationErrors.code = "Solo se permiten letras mayúsculas";
        }
        if (!name) validationErrors.name = "El Campo es Obligatorio";
        if (!client) validationErrors.client = "El Campo es Obligatorio: Ingrese el nombre de un cliente válido";
        return validationErrors;
    };


    const handleClick = () => {
        navigate(-1);
    };

    const handleSearchCustomer = useCallback(async (page = 1) => {
        try {
            const params = new URLSearchParams();
            if (searchTermClient) params.append('search', searchTermClient);

            const response = await apiClient.get(`/clients?${params.toString()}&page=${page}`);

            if (Array.isArray(response.data.results)) {
                setClientsData(response.data.results);
            } else {
                setClientsData([response.data.results]);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsInfoVisible(true);
            }
        }
    }, [searchTermClient]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTermClient) {
                handleSearchCustomer();
            }
        }, 200);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTermClient, handleSearchCustomer]);

    const handleClientChange = (selectedOption) => {
        if (selectedOption) {
            setClient(selectedOption.value);
            setClientSearch(selectedOption.label);
            //setClientsData([]);
        } else {
            setClient("");
            setClientSearch("");
        }
    };

    const clearFieldError = (field, value) => {
        // solo elimina el error si el valor ya no está vacío
        if (value.trim() !== "") {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[field];
                return newErrors;
            });
        }
    };
    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };

    useEffect(() => {
        if (codeDistributor) {
            const fetchDistributor = async () => {
                try {
                    const response = await apiClient.get(`/distributors/${codeDistributor}`);
                    setCode(response.data.coddis);
                    setName(response.data.nomdis);
                    setClient(response.data.codcli);
                    setPurchaseBlock(response.data.purchaseBlock ? 1 : 0);
                    const cliente = await apiClient.get(`/clients/${response.data.codcli}`);
                    setClientSearch(cliente.data.nomcli);
                    //setBlockReason(response.data.blockReason);
                    //console.log("data: ", response.data.blockReason);
                    if (response.data.blockReason === null) {
                        setBlockReason("");
                        //console.log("blockReason: ", blockReason);
                    } else {
                        setBlockReason(response.data.blockReason);
                    }
                } catch (error) {
                    if (error.response && error.response.status === 401) {
                        setIsInfoVisible(true);
                    }
                }
            };
            fetchDistributor();
        }
    }, [codeDistributor]);

    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            if (codeDistributor) {
                const payloadUpdate = {
                    name,
                    client,
                    purchaseBlock,
                    flagActive: !purchaseBlock,
                    blockReason: purchaseBlock ? blockReason : ""
                };
                await apiClient.patch(`/distributors/${codeDistributor}`, payloadUpdate);
            } else {
                const payload = {
                    code,
                    name,
                    client
                };
                await apiClient.post("/distributors", payload);
            }
            setIsSuccessVisible(true);
            setIsErrorVisible(false);
            navigate(-1);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setErrorMessage("Oops!. Ocurrio un error al crear el Distribuidor");
                setIsInfoVisible(true);
            } else if (error.response?.data.message.startsWith("DISTRIBUTOR_AREADY_EXISTS")) {
                setMessageBlock("El código del Distribuidor ya está en uso");
                setNotificationBlock(true);
            } else if (error.response?.data.message.startsWith("CLIENT_ALREADY_EXISTS")) {
                setMessageBlock("Ya existe un Distribuidor designado al Cliente seleccionado.");
                setNotificationBlock(true);
            }
        }
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Distribuidor" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={handleClick}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del Distribuidor</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.code ? "red" : "revert-layer" }}>Código</label>
                        <input
                            type="text"
                            placeholder="Código"
                            value={code}
                            maxLength={10}
                            //onChange={(e) => setCode(e.target.value.toUpperCase()) }
                            onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                if (/^[A-Z]*$/.test(value)) {
                                    setCode(value);
                                }
                                clearFieldError("code", value);
                            }}
                            readOnly={!!codeDistributor}
                        />
                        {errors.code && <p className="error-message">{errors.code}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.name ? "red" : "revert-layer" }}>Nombre</label>
                        <input
                            type="text"
                            placeholder="Nombre"
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                clearFieldError("name", e.target.value);
                            }}
                        />
                        {errors.name && <p className="error-message">{errors.name}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.client ? "red" : "revert-layer" }}>Cliente</label>
                        <Select
                            inputValue={searchTermClient}
                            onInputChange={(val) => setSearchTermClient(val)}
                            value={
                                client
                                    ? {
                                        value: client,
                                        label: clientSearch
                                    }
                                    : null
                            }
                            onChange={handleClientChange}
                            options={clientsData.map((cliente) => ({
                                value: cliente.code,
                                label: cliente.socialReason,
                            }))}
                            placeholder="Seleccione un Cliente"
                            isClearable
                            classNamePrefix="custom-select"
                            className="custom-select-container"
                        />
                        {errors.client && (<p className="error-message">{errors.client}</p>)}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.client ? "red" : "revert-layer" }}>Documento de Identificación</label>
                        <input
                            type="text"
                            placeholder="Documento de Identificación"
                            value={client}
                            onChange={(e) => {
                                setClient(e.target.value);
                                clearFieldError("client", e.target.value);
                            }}
                            readOnly={true}
                        />
                        {errors.client && <p className="error-message">{errors.client}</p>}
                    </div>

                </div>
                <div className="basic-info-form-grid">
                    {codeDistributor && (
                        <div className="basic-info-form-group4">
                            <label>Estado</label>
                            <div className="slider-container" onClick={toggleSwitch}>
                                <div className={`slider-option ${!purchaseBlock ? "active" : "inactive"}`}>
                                    Activo
                                </div>
                                <div className={`slider-option ${purchaseBlock ? "active" : "inactive"}`}>
                                    Inactivo
                                </div>
                            </div>
                        </div>
                    )}
                    {codeDistributor && purchaseBlock ? (
                        <div className="basic-info-form-group">
                            <label>Motivo</label>
                            <input
                                type="text"
                                placeholder="Motivo"
                                value={blockReason}
                                onChange={(e) => setBlockReason(e.target.value)}
                            />
                        </div>
                    ) : (
                        <div></div>
                    )}
                </div>
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(-1);
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button className="basic-custom-button" onClick={handleSave}>
                        <FontAwesomeIcon
                            icon={codeDistributor ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {codeDistributor ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            <SuccessNotification
                message={
                    codeDistributor
                        ? "El Distribuidor se ha Actualizado Correctamente."
                        : "El Distribuidor se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuelve a iniciar sesión"
                isVisible={isInfoVisible}
                onClose={() => setIsInfoVisible(false)}
                onLogout={handleLogout}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={`No se puede Crear el Distribuidor debido a : ${messageBlock}`}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={true}
                    pageNavigate={"/DistributorsList"}
                    whatsApp={false} 
                />
            )}

        </div>
    );
};

export default DistributorsForm;
